<template>
  <el-container
    style="
      display: flex;
      justify-content: center;
      margin: 5vh 5vw;
      max-height: 80vh;
      overflow-y: auto;
      overflow-x: hidden;
    "
  >
    <el-card
      style="width: 700px; height: 840px"
      body-style="display: flex; flex-direction: column; justify-content:center; align-items: center; padding: 0"
    >
      <img
        class="img"
        src="../assets/Final Logo Transparent 2.svg"
        style="
          object-fit: cover;
          width: 300px;
          height: 200px;
          object-position: left center;
          margin: 50px 0 -40px 0;
        "
      />
      <div
        style="
          margin-top: 20px;
          width: 60%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-start;
        "
      >
        <el-form @submit.native.prevent="register" style="width: 100%">
          <el-form-item>
            <span slot="label">
              Organization Information
              <small>
                <el-tooltip placement="right" effect="light">
                  <span slot="content"
                    >Reach out to Revelwood if you have not received your
                    DataMaestro organization ID.</span
                  >
                  <i
                    class="el-icon-info"
                    style="position: relative; left: 2px; bottom: 4px"
                  />
                </el-tooltip>
              </small>
            </span>
            <el-input
              placeholder="Organization ID"
              v-model="$v.organizationId.$model"
              ref="organizationId"
              :class="{
                error: checkValid && $v.organizationId.$invalid,
              }"
            />
          </el-form-item>
          <el-form-item>
            <span slot="label">
              Administrator Information
              <small>
                <el-tooltip placement="right" effect="light">
                  <span slot="content"
                    >The display name will appear throughout the application to
                    publicly identify<br />the user.<br /><br />The password
                    must be between 8 and 32 characters in length, contain
                    only<br />lowercase, uppercase, and numeric characters, and
                    must contain at least one<br />lowercase/uppercase/number.</span
                  >
                  <i
                    class="el-icon-info"
                    style="position: relative; left: 2px; bottom: 4px"
                  />
                </el-tooltip>
              </small>
            </span>
            <el-input
              placeholder="First Name"
              v-model="$v.firstName.$model"
              :class="{
                error: checkValid && $v.firstName.$invalid,
              }"
              @blur="setDisplayName"
            />
            <el-input
              placeholder="Last Name"
              v-model="$v.lastName.$model"
              :class="{
                error: checkValid && $v.lastName.$invalid,
              }"
              @blur="setDisplayName"
            />
            <el-input
              placeholder="Display Name"
              v-model="$v.displayName.$model"
              :class="{
                error: checkValid && $v.displayName.$invalid,
              }"
            />
            <el-input
              placeholder="Email"
              v-model="$v.email.$model"
              type="email"
              :class="{ error: checkValid && $v.email.$invalid }"
            />
            <el-input
              placeholder="Password"
              type="password"
              v-model="$v.password.$model"
              show-password
              :class="{
                error: checkValid && $v.password.$invalid,
              }"
            />
          </el-form-item>
          <el-button
            class="button"
            style="width: 100%; margin-top: 30px"
            native-type="submit"
            >Register</el-button
          >
        </el-form>
      </div>
    </el-card>
  </el-container>
</template>

<script>
import { mapState } from "vuex";
import AuthenticationService from "../services/AuthenticationService";
import {
  required,
  email,
  alphaNum,
  minLength,
  maxLength,
} from "vuelidate/lib/validators";
import Helper from "../utilities/Helper";

/**
 * @vue-data {String} [organization=null] - New user's organization
 * @vue-data {String} [email=null] - New user's email address
 * @vue-data {String} [password=null] - New user's password
 * @vue-data {String} [role=""] - New users's role (controls access within the app)
 * @vue-data {Boolean} [checkValid=false] - Flag that indicates whether to check for errors
 * @vue-computed {Helper} mapState - Maps Vuex state to computed properties
 * @vue-data {Boolean} [showPassword=false] - Flag that indicates whether to show the password text
 */
export default {
  data() {
    return {
      organizationId: null,
      firstName: null,
      lastName: null,
      displayName: null,
      email: null,
      password: null,
      checkValid: false,
    };
  },
  computed: {
    ...mapState(["isUserLoggedIn", "userRole", "instanceId"]),
  },
  methods: {
    handleError: Helper.handleError,
    trim: Helper.trim,
    /**
     * Sets the default display name
     * @function
     */
    setDisplayName() {
      if (this.firstName && this.lastName && !this.displayName) {
        this.displayName = `${this.firstName} ${this.lastName}`;
      }
    },
    /**
     * Creates a new user
     * @async
     * @function
     */
    async register() {
      const loading = this.$loading({
        lock: true,
        //text: "Working",
        background: "rgba(0, 0, 0, 0.3)",
      });
      try {
        this.checkValid = true;

        await AuthenticationService.register({
          organizationId: this.trim(this.organizationId),
          firstName: this.trim(this.firstName),
          lastName: this.trim(this.lastName),
          displayName: this.trim(this.displayName),
          email: this.trim(this.email),
          password: this.password,
        });
        this.$message({
          type: "success",
          message:
            "The new organization was created successfully, and a confirmation email has been sent to the administrator.",
          duration: 5000,
          showClose: true,
        });

        this.checkValid = false;
      } catch (err) {
        this.handleError(err, this, this.instanceId);
      } finally {
        loading.close();
      }
    },
  },
  mounted() {
    this.$refs.organizationId.focus();
  },
  validations() {
    return {
      organizationId: { required },
      firstName: { required },
      lastName: { required },
      displayName: { required },
      email: { required, email },
      password: {
        required,
        alphaNum,
        minLength: minLength(8),
        maxLength: maxLength(32),
        meetsRequirements() {
          const regex = new RegExp(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/);
          return regex.test(this.password);
        },
      },
    };
  },
};
</script>

<style scoped>
.error :deep(.el-input__inner) {
  border: 1px solid red;
  border-radius: 4px;
}
.el-input {
  margin-bottom: 10px;
}
.button {
  background-color: #b3282d;
  color: white;
  border-color: white;
}
.button:focus {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
.button:hover {
  background-color: #9a0f14;
  color: white;
  border-color: white;
  outline: none;
}
</style>
